/* eslint-disable no-duplicate-case */
import React from "react";
import { Breadcrumbs, Paper, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  url: {
    cursor: "pointer",
  },
}));

// function handleClick(event) {
//   event.preventDefault();
// }

function enToZh(enStr) {
  switch (enStr) {
    case "customerMessage": {
      return "顧客訊息回覆";
    }

    case "messageInOrder": {
      return "訂單回復細節";
    }

    case "notificationRecord": {
      return "通知紀錄查詢";
    }

    case "orderManagement": {
      return "訂單管理";
    }
    case "freightMaintain": {
      return "貨運公司維護";
    }
    case "query":{
      return '';
    }
    case "reply": {
      return '';
    }
    case "edit": {
      return "編輯";
    }
    case "add": {
      return "新增";
    }
    case "Registration": {
      return "修改密碼";
    }
    default:
      return enStr;
  }
}

function makeUpUrl(path) {
  const pathArr = path.split("/");
  const urlArr = pathArr.slice(1, pathArr.legth);
  let resoult = [];
  for (let i = 0; i < urlArr.length; i++) {
    let str = "";
    for (let j = 0; j <= i; j++) {
      str += `/${urlArr[j]}`;
    }
    resoult.push({ showStr: urlArr[i], href: str });
  }

  return resoult;
}

export default function ActiveLastBreadcrumb(props) {
  const classes = useStyles();
  const history = useHistory();
  const { path } = props;
  const urls = makeUpUrl(path);

  return (
    <Paper className={classes.paper + " p-5"}>
      <Breadcrumbs aria-label="breadcrumb">
        {urls.map((row, index) => {
          return (
            <span
              key={index}
              className={`${classes.url}`}
              color="inherit"
              onClick={() => {
                history.replace(`${row.href}`);
              }}
            >
              {enToZh(row.showStr)}
            </span>
          );
        })}
      </Breadcrumbs>
    </Paper>
  );
}
